import { InputLabelStateType, } from '@kubit/web-ui-components/inputLabel/types';
import { FONT_WEIGHT } from '../../foundations/typography';
import { Z_INDEX } from '../../foundations/zIndex';
import { TextVariantType } from '../text/variants';
const commonStateStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    ...STATE_TOKENS,
    container: {
        z_index: Z_INDEX.INTERN_1,
        display: 'flex',
        align_items: 'flex-start',
        gap: FOUNDATIONS.spacing_100,
        ...STATE_TOKENS.container,
    },
    label: {
        font_weight: FONT_WEIGHT.font_regular,
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        color: FOUNDATIONS.color_neutral_font_50,
        ...STATE_TOKENS.label,
    },
});
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    [InputLabelStateType.FOCUSED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputLabelStateType.FOCUSED] }),
    },
    [InputLabelStateType.FILLED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputLabelStateType.FILLED] }),
    },
    [InputLabelStateType.EMPTY]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputLabelStateType.EMPTY] }),
    },
    [InputLabelStateType.ERROR_EMPTY]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputLabelStateType.ERROR_EMPTY] }),
    },
    [InputLabelStateType.ERROR_FILLED]: {
        ...commonStateStyles(FOUNDATIONS, { ...STATE_TOKENS[InputLabelStateType.ERROR_FILLED] }),
    },
    [InputLabelStateType.DISABLED_EMPTY]: {
        ...commonStateStyles(FOUNDATIONS, {
            label: { color: FOUNDATIONS.color_accent_disabled_font_100 },
            ...STATE_TOKENS[InputLabelStateType.DISABLED_EMPTY],
        }),
    },
    [InputLabelStateType.DISABLED_FILLED]: {
        ...commonStateStyles(FOUNDATIONS, {
            label: { color: FOUNDATIONS.color_accent_disabled_font_50 },
            ...STATE_TOKENS[InputLabelStateType.DISABLED_FILLED],
        }),
    },
});
//# sourceMappingURL=commonStyles.js.map